@if (!utilService.isMobile()) {
  <div class="page-title-container d-flex">
    <div class="page-title flex-grow-1 ">
      <div class="mb-0 ">
        <div class="d-flex align-items-center">
          <div class="pl-2 pr-2 ">
            <a class="d-inline-flex" href="javascript:void(0)" (click)="listResource()">
              <img src="assets/images/grid-back.png"></a>
            </div>
            <div class="">{{'pagename.cdss_master' | translate | async }} </div>
          </div>
        </div>
      </div>
      <div class="component-container "></div>
    </div>
  }
  @if (fg && controls) {
    <div class="main-content-container shadow border rounded">
      <div class="form-container">
        <form [formGroup]="fg" (ngSubmit)="onSubmit()">
          <div style="margin-bottom: 100px;">
            <div class="row pl-3 w-100">
              <div class="col-12 col-sm-4 form-group kx-control fix">
                <label class="control-label font-weight-bold required" for="">CDSS Name</label>
                <input type="text" name="patient_name" formControlName="cdss_name" class="form-control">
              </div>
              <input type="hidden" name="facility_id" formControlName="facility_id" class="form-control">
              <div class="col-12 col-sm-4 form-group kx-control fix">
                <label class="control-label font-weight-bold required" for="">Chief Complaints</label>
                <kx-multiselect-dropdown tabindex="-1" [questions]="chiefcomplaint.question" name="chief_complaints"
                  [controlName]="fg" [placeholder]="'Select Chief Complaint'" [data]="chiefcomplaint.datasource"
                  [formControlName]="'chief_complaints'" [settings]="chiefcomplaint.defaultsetting" [disabled]="route.snapshot.params.action && route.snapshot.params.action == 'view'">
                </kx-multiselect-dropdown>
              </div>
              <div class="col-12 col-sm-4 form-group kx-control fix">
                <label class="control-label font-weight-bold" for="">Remarks</label>
                <textarea name="patient_name" formControlName="remarks" class="form-control"></textarea>
              </div>
            </div>
            <div class="custom-block" formArrayName="transaction">
              @for (row of getRows().controls; track row; let i = $index) {
                <div>
                  <div class="row" [formGroup]="row">
                    <div class="col-12">
                      <div id="accordion{{i}}" class="accordion p-0 ">
                        @if (row.value.parent_id != '') {
                          <div class="accordion-header shadow-common-accordion" data-toggle="collapse"
                            [attr.data-target]="'#acc'+i" (click)="showId('acc'+i);">
                            <div class="d-flex align-items-center justify-content-between p-2">
                              <div class="">
                                <a class="accordion-title">
                                  {{row.value.parent_text}}
                                  <div class="fav-bookmark ml-3">
                                    <div class="bookmark-chip active" >{{row.value.answer_text}}</div>
                                  </div>
                                </a>
                              </div>
                              <div class="accordion-icon p-0">
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                              </div>
                            </div>
                          </div>
                        }
                        <div id="acc{{i}}" class="accordion-body collapse" [attr.data-parent]="'#accordion'+i" [ngStyle]="route.snapshot.params && route.snapshot.params.action ? {'display': 'block'}: {'display': 'none'}">
                          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-12 p-3">
                            <div class="row">
                              @for (control of controls[i]; track control) {
                                @if (control.controlType!='hidden' && control.visible!=false) {
                                  <div class="col-12 col-sm-4"
                                    >
                                    <div class="col-12 p-0 kx-parent-block">
                                      <dhs-form-question [question]="control" [form]="row"
                                        (valueChanged)="onValueChanged($event,group,i,row)">
                                      </dhs-form-question>
                                    </div>
                                  </div>
                                }
                              }
                              <!-- (click)="answerSelected(i,row, pill);pill.disabled =true" [ngClass]="pill.disabled ? 'active': ''" [ngStyle]="pill.disabled ? {'cursor': 'not-allowed'}: {'cursor': 'pointer'}"-->
                              @for (pill of row.value.answers; track pill; let i = $index) {
                                <div class="fav-bookmark ml-3" #pill
                                  >
                                  <div class="bookmark-chip active" style="cursor: not-allowed;">
                                    <span class="pr-2">{{pill.text}}</span>
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
          <div class="col-12 text-center">
            @if (!route.snapshot.params.action) {
              <button type="submit" class="primary-btn submitButton">Submit
                <i class="fa fa-check ml-2"></i>
              </button>
            }
            @if (route.snapshot.params.action && route.snapshot.params.action == 'modify') {
              <button type="submit" class="primary-btn submitButton">Update
                <i class="fa fa-check ml-2"></i>
              </button>
            }
          </div>
        </form>
      </div>
    </div>
  }